
export function isNumber(value) {
    if (value.trim() === "") {
      return false;
    }
    return !isNaN(Number(value));
}